import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SpecLine } from 'src/app/features/asset-management/models/SpecLine';
import { UpdateSpecificationLine } from 'src/app/features/asset-management/models/request/UpdateSpecificationLine';
import { CustomerReferential } from 'src/app/features/customer/models/CustomerReferential';
import { environment } from 'src/environments/environment';
import { areStringArraysEqual } from '../helper/Helper';
import { SpecificationLineDefinition } from '../../features/asset-management/models/request/SpecificationLineDefinition';
import { Products } from './models/Products';

export interface ValidCombinationResponse {
  data: boolean;
  error: Array<string>;
}

export interface CustomerReferenctialResponse {
  data: CustomerReferential;
}

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private readonly http = inject(HttpClient);

  getProducts(): Observable<Products> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.products}`;
    return this.http.get<Products>(url);
  }

  getCustomerReferential(): Observable<CustomerReferenctialResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getAllReferential}`;
    return this.http.get<CustomerReferenctialResponse>(url);
  }

  isProductCombinationsValid(
    updateSpecificationLine: UpdateSpecificationLine,
    specificationLine: SpecLine
  ): Observable<ValidCombinationResponse> {
    const specificationLineDefinition: SpecificationLineDefinition = {
      makes: updateSpecificationLine.makes,
      series: updateSpecificationLine.series,
      sizes: updateSpecificationLine.sizes
    };
    const valid: ValidCombinationResponse = { data: true, error: [] };

    // if any of two combinations in makes, series and sizes is all, return true
    if (
      (specificationLineDefinition.makes.includes('All') && specificationLineDefinition.series.includes('All')) ||
      (specificationLineDefinition.series.includes('All') && specificationLineDefinition.sizes.includes('All')) ||
      (specificationLineDefinition.makes.includes('All') && specificationLineDefinition.sizes.includes('All'))
    ) {
      return of(valid);
    }

    //check if makes series and sizes have been edited
    if (
      areStringArraysEqual(specificationLineDefinition.makes, specificationLine.makes) &&
      areStringArraysEqual(specificationLineDefinition.series, specificationLine.series) &&
      areStringArraysEqual(specificationLineDefinition.sizes, specificationLine.sizes)
    ) {
      return of(valid);
    }
    return this.checkValidProductCombinations(specificationLineDefinition);
  }

  private checkValidProductCombinations(specificationLineDefinition: SpecificationLineDefinition): Observable<ValidCombinationResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.productCombinations}`;
    return this.http.post<ValidCombinationResponse>(url, specificationLineDefinition);
  }
}
